/**
 * Guardia de ruta para panel de administración
 * Sprint 7 - HU-FE-09: Solo permite acceso a usuarios con is_admin === true
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores';
import { Spinner } from '../ui';

interface AdminRouteProps {
    children: React.ReactNode;
}

export function AdminRoute({ children }: AdminRouteProps) {
    const location = useLocation();
    const { user, isInitialized, isLoading } = useAuthStore();

    // Mostrar loading mientras se verifica la sesión
    if (!isInitialized || isLoading) {
        return (
            <div className="route-loading">
                <Spinner size="large" />
            </div>
        );
    }

    // Sin usuario → login
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    // No es admin → home
    if (!user.is_admin) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
}
